import { Component, OnInit } from '@angular/core';
import { getObservableFromAsyncValueSafe } from '@ordersnproducts/modules/shared/models/async-value';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AbstractField } from '../../models/field-configs/abstract-field';
import { SeparatorField } from '../../models/field-configs/field-config.interface';

@Component({
  selector: 'app-form-separator',
  templateUrl: './form-separator.component.html',
  styleUrls: ['./form-separator.component.scss'],
})
export class FormSeparatorComponent extends AbstractField implements OnInit {
  // Config
  public config: SeparatorField;
  private ngDestroy = new Subject();

  // View
  public text: string;
  public visible = true;
  public transparent = false;

  constructor() {
    super();
  }

  ngOnInit() {
    if (this.config.transparent) {
      this.transparent = this.config.transparent;
    }

    if (this.config.visible !== undefined) {
      getObservableFromAsyncValueSafe(this.config.visible)
        .pipe(takeUntil(this.ngDestroy))
        .subscribe(fieldVisibility => (this.visible = fieldVisibility));
    }
  }
}
